import { Tabs, Divider } from 'antd';
import { CalendarOutlined, ProfileOutlined ,RocketOutlined} from '@ant-design/icons';
import YourJobsAll from '../YourJobsAll';
import MultiJobAmin from './MultiJobAdmin';
import MultiYourJobsPerformance from './MultiYourJobsPerformance';
import { useEffect, useState,useContext } from 'react';
import { CommonContext } from '../../Context';
import JobboardBoostsAdmin from '../JobboardBoardsAdmin';
import WebLinks from '../../api/WebLinks';
import APIUtils from '../../api/APIUtils';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
//import YourJobsPerformance from './YourJobPerformance';
const { TabPane } = Tabs;

const MultiYourJobsContainer = (props) => {
  const [loader,setLoader]=useState(false);
  const [showBoost,setShowBoost]=useState(false);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  
  //Function on page load
  useEffect(() => {
    getBuyerDetails();
    trackPageAccess(buyerId,window.location.href)
  }, []);

  const getBuyerDetails = async () => {
    setLoader(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetBuyerDetails + buyerId);
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      setShowBoost(response.resultObj?.data?.showBoost);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
 
	//Render
	return (
		<div>
			<Tabs defaultActiveKey="1">
			<TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />Your Jobs</span> }
        key={1}
      >
        <MultiJobAmin/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><ProfileOutlined className='text-xl' />Performance</span> }
        key={2}
      >
        <MultiYourJobsPerformance/>
      </TabPane>
      {/* {showBoost?
      <TabPane
        tab={ <span className='uppercase'><RocketOutlined className='text-xl' />Buy Jobboard boosts</span> }
        key={3}
      >
        <JobboardBoostsAdmin />
      </TabPane>
      :null} */}
			</Tabs>
		</div>
	);
};

export default MultiYourJobsContainer;